/**
 * SEO Optimization Script
 * Handles javascript caching, prevents layout shifts, and improves performance
 */

// Service Worker for caching JavaScript resources
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('/service-worker.js')
      .then(function(registration) {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(function(error) {
        console.log('ServiceWorker registration failed: ', error);
      });
  });
}

// Prevent Cumulative Layout Shifts (CLS)
document.addEventListener('DOMContentLoaded', function() {
  // Pre-calculate and set heights for dynamic content containers
  const dynamicContainers = document.querySelectorAll('[data-dynamic-height]');
  
  dynamicContainers.forEach(container => {
    // Get the aspect ratio from data attribute or use default values
    const aspectRatio = container.getAttribute('data-aspect-ratio') || '16:9';
    const [width, height] = aspectRatio.split(':').map(Number);
    
    // Calculate and set height based on container width
    const containerWidth = container.offsetWidth;
    const calculatedHeight = (containerWidth * height) / width;
    
    container.style.height = `${calculatedHeight}px`;
  });
  
  // Process image elements to prevent layout shifts
  const images = document.querySelectorAll('img:not([width]):not([height])');
  
  images.forEach(img => {
    if (img.complete) {
      addDimensions(img);
    } else {
      img.addEventListener('load', function() {
        addDimensions(img);
      });
    }
  });
  
  function addDimensions(img) {
    // Only add dimensions if they aren't already set
    if (!img.getAttribute('width') && !img.getAttribute('height')) {
      img.setAttribute('width', img.naturalWidth);
      img.setAttribute('height', img.naturalHeight);
    }
  }
  
  // Add preconnect for external resources
  const head = document.head;
  const preconnectDomains = [
    'https://cdn.shopify.com',
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com'
  ];
  
  preconnectDomains.forEach(domain => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = domain;
    link.crossOrigin = 'anonymous';
    head.appendChild(link);
  });
});

// Optimize font loading
function optimizeFonts() {
  // Add Font Loading API to reduce the chance of FOUT (Flash of Unstyled Text)
  if ('fonts' in document) {
    const font = new FontFace('Albert Sans', 'url(/assets/albert-sans.woff2) format("woff2")', {
      style: 'normal',
      weight: '400',
      display: 'swap'
    });
    
    font.load().then(function() {
      document.fonts.add(font);
      document.documentElement.classList.add('fonts-loaded');
    }).catch(function(error) {
      console.log('Font loading failed:', error);
    });
  }
}

// Call font optimization
optimizeFonts();

// Defer loading of non-critical resources
function deferNonCriticalResources() {
  // Add logic to defer non-essential scripts and styles
  window.addEventListener('load', function() {
    // Defer loading analytics
    setTimeout(function() {
      // Load analytics scripts here after the page has fully loaded
      const analyticsScript = document.createElement('script');
      analyticsScript.src = 'https://cdn.shopify.com/shopifycloud/shopify_stats/storefront-renderer.js';
      analyticsScript.defer = true;
      document.head.appendChild(analyticsScript);
    }, 1000); // 1 second delay
  });
}

// Initialize deferred resources
deferNonCriticalResources();
